<template>
  <div class="myWallet">
    <!-- 头部 -->
    <div class="myWallet-top">
      <div class="iconfont iconzuojiantou jian" @click="goBack"></div>
      <div>我的钱包</div>
      <div></div>
    </div>
    <!-- 余额总计 -->
    <div class="myWallet-balance">
      <div class="balance">
        <div class="balance-back">
          <div class="balance-back-left">
            <div class="total">余额总计</div>
            <div class="number"><span>￥</span><span>{{totalAmount}}</span></div>
          </div>
          <div class="balance-back-right">
            <div class="detail" @click="toQuery"><span>查看明细</span> <span> > </span></div>
            <div class="advance" @click="withDraw">提现</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 我的电子账户 -->
    <div class="myWallet-accountNo" style="margin:15px 0">
      <div class="accountNo-title">
        <div class="my-accountNo">我的电子账户</div>
        <!-- <div class="check-detail">查看详情 ></div> -->
      </div>
      <div class="accountNo-paCart">
        <div class="accountNo-paCartNo">{{bankAccount}}</div>
      </div>
      <div class="account-point">* 绑定银行卡，即可激活平安银行电子账户用于交易</div>
    </div>

    <!-- 我的银行卡 -->
    <div class="myWallet-accountNo">
      <div class="accountNo-title">
        <div class="my-accountNo">我的银行卡</div>
        <div class="check-detail" @click="checkBankDetail">查看详情 ></div>
      </div>
      <div class="accountNo-paCart accountNo-bank">
        <div class="bank-block">
          <div class="bank-card">{{bankName}}</div>
          <div class="bank-cardNo">{{bankNo}}</div>
        </div>
        <div class="bank-img">
          <div class="img-back">
            <img :src="bankImg" alt="">
          </div>
        </div>
      </div>
      <div class="account-point">* 绑定银行卡，即可激活平安银行电子账户用于交易</div>
    </div>

    <!-- 弹框 -->
    <van-overlay :show="overlayShow">
      <div class="card-bind-wrapper" @click.stop>
        <div class="card-bind-block">
          <div class="bind-block-title">短信验证</div>
          <div class="bind-block-detail">
            <div class="bind-block-detail-send">
              您还没有授权查看您的电子账户余额，授权后才能查看，请注意查收{{mobile}}短信验证码
            </div>
          </div>
          <div class="bind-field-code">
            <van-field
              v-model="formData.smsCode"
              input-align="left"
              clearable
              center
              placeholder="请输入短信验证码"
              class="bink-field-input-back"
            >
              <template #button>
                <van-button
                  size="small"
                  type="primary"
                  class="bind-block-code"
                  @click="sendCode"
                  v-show="codeShow"
                  >发送验证码</van-button
                >
                <van-button
                  size="small"
                  type="primary"
                  class="bind-block-code"
                  :disabled="disCode"
                  @click="sendCode"
                  v-show="!codeShow"
                  >{{ count }}s</van-button
                >
              </template>
            </van-field>
          </div>

          <div class="bind-modify-submit">
            <div class="bind-modify" @click="backModify">取消</div>
            <div class="bind-modif-rightline"></div>
            <div class="bind-submit" @click="onSubmit">确定</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>

</template>
<script>
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
  data(){
    return{
      bankImg:"",
      overlayShow:false,
      count: "",
      codeShow: true,
      disCode: false,
      timer: null,
      mobile:"",
      totalAmount:"",
      bankAccount:"",
      bankName:"",
      bankNo:"",
      formData:{
        smsCode:"",
        businessNo:"",
        otpOrderNo:"",
      },
      accountId: ''
    }
  },
  mounted(){
    this.myWalletDedail()
  },
  methods:{
    myWalletDedail(){
      http.post(config.myWallet).then(({code,data,message})=>{
        if(code===0){
          if(data.code===200){
            this.bankNo=data.bindCardDetail[0].bankNo;
            this.bankName=data.bindCardDetail[0].bankName;
            this.mobile=data.mobile;
            this.totalAmount=data.totalAmount;
            this.bankAccount=data.myAccount.bankAccount;
            this.accountId = data.myAccount.accountId
            this.bankImg=`https://bpo-dev.oss-cn-beijing.aliyuncs.com/client/bank_logo/${data.bindCardDetail[0].bankCode}.png`
          }else if(data.code===202){
            this.overlayShow=true;
          }
        }else{
          this.$toast.fail(message)
        }
      })
    },
    sendCode(){
      http.post(config.balanceSignSendSms).then(({code,data})=>{
        if(code===0 && data.code===200){
          this.timerFun();
          this.formData.businessNo=data.businessNo;
          this.formData.otpOrderNo=data.otpOrderNo;
        }
      })
    },
    timerFun() {
      // 倒计时
      this.disCode = true;
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    backModify() {
      this.overlayShow = false;
      window.history.go(-1);
    },
    onSubmit(){
      console.log(this.formData)
      http.post(config.balanceSign,this.formData).then(({code,data})=>{
        if(code===0 && data.code===200){
          this.$toast.success(data.message)
          this.overlayShow=false;
          this.myWalletDedail()
        }else{
          this.$toast.fail("授权失败")
        }
      })
    },
    goBack(){
      this.$router.push("../../updateInfo")

    },
    withDraw(){
      this.$router.push({path:'/checkDetail'})
    },
    checkBankDetail(){
      this.$router.push({path:'/bankDetail'})
    },
    toQuery(){
      this.$router.push({path:`../detailQuery?accountId=${this.accountId}&totalAmount=${this.totalAmount}`})
    },
  }

}
</script>

<style lang="less" scoped>
.myWallet{
  .myWallet-top{
    display: flex;
    justify-content: space-between;
    color: #333333;
    font-size: 35px;
    align-items: center;
    margin-bottom: 30px;
    color: #333333;
    font-size: 35px;
    .jian{
      font-size: 35px;
    }
  }
  padding: 20px;
  .myWallet-balance{
    .balance{
      width: 100%;
      display: flex;
      justify-content: center;
      .balance-back{
        width: 90%;
        height: 246px;
        background: url(../../../assets/img/yuezongji.png) no-repeat;
        background-size: contain;
        display: flex;
        justify-content: space-between;
        padding: 40px;
        box-sizing: border-box;
        color: #ffffff;
        .balance-back-left{
          .total{
            font-size: 32px;
            text-align: left;
            margin-bottom: 44px;
          }
          .number{
            font-size: 60px;
            text-align: left;
          }

        }
        .balance-back-right{
          .detail{
            font-size: 28px;
            margin-bottom: 66px;
          }
          .advance{
            width: 133px;
            height: 48px;
            background: #858BAF;
            text-align: center;
            line-height: 48px;
            border-radius: 24px;
          }

        }
      }
    }
  }
  .myWallet-accountNo{
    padding: 40px;
    .accountNo-title{
      display: flex;
      justify-content: space-between;
      padding: 0 16px;
      .my-accountNo{
        font-size: 36px;
        color: #222222;

      }
      .check-detail{
        color: #0681FD;
        font-size: 26px;
      }

    }
    .accountNo-paCart{
      width: 100%;
      height: 250px;
      background: url(../../../assets/img/pinganyinhang.png) no-repeat;
      background-size: contain;
      position: relative;
      .accountNo-paCartNo{
        position: absolute;
        left: 126px;
        bottom:60px;
        color: #ffffff;
        font-size: 28px;

      }
    }
    .accountNo-bank{
      text-align: left;
      color: #ffffff;
      display: flex;
      padding: 46px 50px;
      box-sizing: border-box;
      justify-content: space-between;
      .bank-block{
        .bank-card{
          font-size: 32px;
        }
        .bank-cardNo{
          font-size: 28px;
          margin-top: 10px;
        }
      }
      .bank-img{
        .img-back{
          width: 80px;
          height: 80px;
          background: #ffffff;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
          width: 80%;
          height: 80%;
        }
        }
      }
    }
    .accountNo-bank{
      background: url(../../../assets/img/yinhangka.png) no-repeat;
      background-size: contain;
    }
    .account-point{
      color: #999999;
      font-size: 24px;
      text-align: left;
      padding: 0 20px;
    }

  }
  .card-bind-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .card-bind-block {
    width: 90%;
    height: 490px;
    background-color: #fff;
    border-radius: 10px;
    padding: 30px;
    box-sizing: border-box;
    .bind-block-title {
      font-size: 32px;
      color: #333333;
      margin-bottom: 20px;
      font-weight: 500;
    }
    .bind-block-detail {
      color: #666666;
      font-size: 28px;
      margin-bottom: 60px;
      .bink-block-detail-send {
      }
      .bink-block-detail-get {
      }
    }
    .bind-field-code {
      .bind-block-code {
        width: 180px;
        height: 74px;
        background: #4da5ff;
        border: none;
        border-radius: 45px;
        height: 90px;
        margin-right: -25px;
      }
      .bink-field-input-back {
        background: rgba(6, 129, 253, 0.04);
        border-radius: 45px;
        height: 90px;
      }
    }
    .bind-modif-rightline {
      height: 100px;
      width: 1px;
      background: #ececec;
    }
    .bind-modify-submit {
      width: 100%;
      height: 100px;
      border-top: 1px solid #ececec;
      font-size: 34px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 60px;
      .bind-submit {
        color: #0681fd;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/wallet/myWallet/index.vue